import React, { FC, PropsWithChildren } from 'react';

import { MAIN_CONTENT_ID, SkipToMainContent } from './SkipToMainContent';

const Plain: FC<PropsWithChildren> = props => (
  <>
    <SkipToMainContent />
    <main id={MAIN_CONTENT_ID} tabIndex={-1}>
      {props.children}
    </main>
  </>
);

export default Plain;
